export default __webpack_public_path__ + "static/Flow-702e45aff299c0c0f05441483c46e20d.png";